<script>

  export let legends = []; // Array<{ color: string, label: string }>

</script>

<style>

  .legends-container {
    margin: 0px 2rem;
  }

  .legends-container > label {
    font-weight: bold;
  }

  .legends-container > ul {
    list-style: none;
    border: 2px solid black;
    padding: 0.5rem;
  }

  .legends-container > ul > li:not(:last-child) {
    margin-bottom: 0.2rem;
  }

  .legend-icon {
    padding: 0px 0.5rem 0px 0.5rem;
    font-size: 0.7rem;
  }

</style>

<div class="legends-container">
  <label>Legends</label>
  <ul>
    {#each legends as legend}
      <li>
        <span class="legend-icon" style="background-color: {legend.color}"></span>
        &nbsp;
        <span style="color: {legend.color}">{legend.label}</span>
      </li>
    {/each}
  </ul>
</div>
